import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HealthService extends ApiService<any> {

  constructor(protected http: HttpClient) {
    super('health');
  }
  updateConsent(id: number) {
    let basePath = environment.isLocal ? 'http://localhost:5037/' : `${window.location.origin}/`;
    let path = `${basePath}health`;
    return this.http.get(`${path}/${id}/consent`);
    //return this.http.get(`${path}`);
  }
}
